<template>
    <div data-toggle="datepicker"></div>

    <div class="" v-show="playerInfo.isShowData">
        <div class="player-overview-container">
            <div class="player-overview-left">
                <div class="player-team">
                     <router-link :to="{ path:`/${currentLocale}/${currentSportType}/team/${playerInfo.teamName}/${playerInfo.teamId}/overview` }">
                         <Icon :logoUrl="playerInfo.teamLogo" class="logo-size" o></Icon>
                     </router-link>
                    <!-- <img src="../../../../../static/images/icons/aspn_icon/icon_avatar.png" /> -->
                    <div>
                        <router-link :to="{ path:`/${currentLocale}/${currentSportType}/team/${playerInfo.teamName}/${playerInfo.teamId}/overview` }">
                            <div class="player-team-name">
                                {{playerInfo.teamName}}
                            </div>
                        </router-link>
                        <div class="player-team-date" v-if="playerInfo.endDateContract">
                            {{$t('CONTRACT_UNTIL')}}
                            {{ formatDateEndContract(playerInfo.endDateContract) }}
                        </div>
                    </div>
                </div>

                <div class="honours-awards-container player-info-mobile">
                    <div class="honours-awards-title">
                        {{$t('PLAYER_INFO')}}
                    </div>

                    <div class="player-info-list">
                        <div class="player-info-item" v-for="(item,index) in playerInfoList">
                            <div class="player-info-title">
                                {{ $t(item.name) }}
                            </div>
                            <div class="player-info-value">
                                {{ playerInfo[item.keyName] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="player-league">
                    <div class="player-league-box">
                        <!-- {{ `/${currentLocale}/${currentSportType}/${playerInfo.countryName}/${playerInfo.leagueKey}?leagueId=${playerInfo.leagueId}` }} -->
                        <router-link :to="{ 
                            path:`/${currentLocale}/${currentSportType}/${playerInfo.countryName}/${playerInfo.leagueKey}`,
                            query: {
                                leagueId: playerInfo.leagueId
                            }
                        }">
                        
                            <leagueIcon :icon="playerInfo.leagueKey" className="logo-size">
                                <Icon
                                    :logoUrl="playerInfo.leagueLogo"
                                    :category="'country'"
                                    class="logo-size"
                                ></Icon>
                            </leagueIcon>
                        </router-link>
                        <!-- <Icon :logoUrl="playerInfo.leagueLogo" class="logo-size" o></Icon> -->
                        <!-- <img src="../../../../../static/images/icons/aspn_icon/icon_avatar.png" /> -->
                        <div>
                            <div class="player-league-country">
                                {{playerInfo.countryName}}
                            </div>
                            <div class="player-league-name">
                                {{playerInfo.leagueName}}
                                {{playerInfo.leagueSeason}}
                            </div>
                        </div>
                    </div>
                    <div class="player-league-data">
                        <div class="player-league-data-item">
                            <div class="player-league-data-item-title">{{$t('APPEARANCES')}}</div>
                            <div class="player-league-data-item-value">-</div>
                        </div>
                        <div class="player-league-data-item">
                            <div class="player-league-data-item-title">{{$t('GOALS')}}</div>
                            <div class="player-league-data-item-value">-</div>
                        </div>
                        <div class="player-league-data-item">
                            <div class="player-league-data-item-title">{{$t('ASSISTS')}}</div>
                            <div class="player-league-data-item-value">-</div>
                        </div>
                    </div>
                </div>

                <div class="honours-awards-container" v-if="false">
                    <!-- <div class="honours-awards-title">
                        {{$t('HONOURS_AND_AWARDS')}}
                    </div>
                    <div class="honours-awards-list">
                        <div class="honours-awards-item" v-for="a in 3">
                            <div class="player-league-box">
                                <img src="../../../../../static/images/icons/aspn_icon/icon_avatar.png" />
                                <div>
                                    <div class="player-league-country">
                                        England
                                    </div>
                                    <div class="player-league-name">
                                        Primier League
                                    </div>
                                </div>
                            </div>
                            <div class="honours-awards-child-list">
                                <div class="honours-awards-child-item" v-for="b in 2">
                                    <img src="../../../../../static/images/icons/aspn_icon/icon_avatar.png" />
                                    <div class="honours-awards-child-name">
                                        FA Cup
                                        <span class="honours-awards-child-date">(22/23)</span>
                                    </div>
                                    <div class="honours-awards-child-value">
                                        1
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="player-overview-center">
                <div class="honours-awards-container carrer-container">
                    <div class="carrer-awards-title">
                        {{$t('CARRER_HISTORY')}}
                    </div>

                    <NoData text="CAREER_HISTORY_NO_DATA" />

                    <!-- <table class="career-history-table">
                        <tr class="career-history-table-title">
                            <td>{{$t('CARRER')}}</td>
                            <td>
                                <img src="../../../../../static/images/icons/aspn_icon/player/icon_match_field_mobile.png"
                                    v-if="isMobile" />
                                <img src="../../../../../static/images/icons/aspn_icon/player/icon_match_field.png"
                                    v-else />
                            </td>
                            <td>
                                <img src="../../../../../static/images/icons/aspn_icon/player/icon_ball_mobile.png"
                                    v-if="isMobile" />
                                <img src="../../../../../static/images/icons/aspn_icon/player/icon_ball.png" 
                                    v-else />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="player-team">
                                    <img src="../../../../../static/images/icons/aspn_icon/icon_avatar.png" />
                                    <div>
                                        <div class="player-team-name">
                                            Manchester City
                                        </div>
                                        <div class="player-team-date">
                                            Jul 2022 - Now
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                111
                            </td>
                            <td class="text-center">
                                104
                            </td>
                        </tr>
                    </table>

                    <table class="career-history-table national-team">
                        <tr class="career-history-table-title">
                            <td>{{$t('NATIONAL_TEAM')}}</td>
                            <td>
                                <img src="../../../../../static/images/icons/aspn_icon/player/icon_match_field_mobile.png"
                                    v-if="isMobile" />
                                <img src="../../../../../static/images/icons/aspn_icon/player/icon_match_field.png"
                                    v-else />
                            </td>
                            <td>
                                <img src="../../../../../static/images/icons/aspn_icon/player/icon_ball_mobile.png"
                                    v-if="isMobile" />
                                <img src="../../../../../static/images/icons/aspn_icon/player/icon_ball.png" 
                                    v-else />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="player-team">
                                    <img src="../../../../../static/images/icons/aspn_icon/icon_avatar.png" />
                                    <div>
                                        <div class="player-team-name">
                                            Manchester City
                                        </div>
                                        <div class="player-team-date">
                                            Jul 2022 - Now
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                111
                            </td>
                            <td class="text-center">
                                104
                            </td>
                        </tr>
                    </table> -->
                </div>
            </div>
            <div class="player-overview-right">
                <div class="honours-awards-container">
                    <div class="honours-awards-title">
                        {{$t('TRANSFER_HISTORY')}}
                    </div>

                    <div class="transfer-history-list" v-if="playerInfo.transferData?.length > 0">
                        <div class="transfer-history-item" v-for="(item,index) in playerInfo.transferData">
                            <div class="transfer-history-title">
                                <div class="transfer-history-amount">
                                    {{ item.type === 'Free' ? '-' : item.type }}
                                </div>
                                <div >
                                    {{formatDateTransfer(item.date)}}
                                </div>
                            </div>
                            <div class="player-league-box">
                                <Icon :logoUrl="item.toLogo"></Icon>
                                <div>
                                    <div class="player-league-country">
                                        -
                                    </div>
                                    <div class="player-league-name">
                                        {{ item.to }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <NoData v-else />
                </div>

                <!-- <pre>
                    {{ playerInfo.transfers }}
                </pre> -->
            </div>
        </div>


        <!-- <div class="team-info__overview-card" >
            <div class="team-info__overview-header">{{$t('GENERAL')}}</div>
            <div class="team-info__overview-body">
                <div class="">{{$t('NAME')}}</div>
                <div class="">{{playerInfo.name===null ?'-':playerInfo.name}}</div>
            </div>
                <div class="team-info__overview-body">
                <div class="">{{$t('TEAM')}}</div>
                <div class="">{{playerInfo.team===null ?'-':playerInfo.team}}</div>
            </div>
            <div class="team-info__overview-body">
                <div class="">{{$t('NATIONALITY')}}</div>
                <div class="">{{playerInfo.nationality===null ?'-':playerInfo.nationality}}</div>
            </div>
            <div class="team-info__overview-body">
                <div class="">{{$t('BIRTHDATE')}}</div>
                <div class="">{{playerInfo.birthdate===null ?'-':playerInfo.birthdate}}</div>
            </div>
            <div class="team-info__overview-body">
                <div class="">{{$t('AGE')}}</div>
                <div class="">{{playerInfo.age===null ?'-':playerInfo.age}}</div>
            </div>
            <div class="team-info__overview-body">
                <div class="">{{$t('POSITION')}}</div>
                <div class="">{{playerInfo.position===null ?'-':playerInfo.position}}</div>
            </div>
            <div class="team-info__overview-body">
                <div class="">{{$t('HEIGHT')}}</div>
                <div class="">{{playerInfo.height===null ?'-':playerInfo.height}}</div>
            </div>
            <div class="team-info__overview-body">
                <div class="">{{$t('WEIGHT')}}</div>
                <div class="">{{playerInfo.weight===null ?'-':playerInfo.weight}}</div>
            </div>
        </div>
        <div class="team-info__overview-card" v-if="playerInfo.honours">
            <div class="team-info__overview-header">{{$t('TROPHIES')}}</div>
            <div class="team-info__overview-body" v-for="(o, index) in playerInfo.honours" :key="index">
                <div class="">
                    <span>{{$t(o.country)}}</span>
                    <span class="mlr-02rem">:</span>
                    <span>{{$t(o.league)}}</span>
                    <span class="mlr-02rem">-</span>
                    <span>{{$t(o.status)}}</span>
                </div>
                <div class="">{{o.count}}</div>
            </div>
        </div> -->
    </div>
    <div class="no-data" v-show="!playerInfo.isShowData">{{$t('NO_OVERVIEW')}}</div>
</template>

<script>
import leagueIcon from '@/components/Icon/LeagueIcon.vue'
import {mapGetters,mapActions} from 'vuex'
import config from "@/js/config.js";
import $ from 'jquery'
export default {
    data() {
        return {
            cnLocaleList: config.cnLocaleList,
            playerInfoList: [
                {
                    name: 'NATIONALITY',
                    keyName: 'nationality'
                },
                {
                    name: 'POSITION',
                    keyName: 'position'
                },
                {
                    name: 'DATE_OF_BIRTH',
                    keyName: 'birthdate'
                },
                {
                    name: 'AGE',
                    keyName: 'age'
                },
                {
                    name: 'HEIGHT',
                    keyName: 'height'
                },
                {
                    name: 'WEIGHT',
                    keyName: 'weight'
                }
            ]
        }
    },
    components: {
        leagueIcon
    },
    computed: {
        ...mapGetters([
            'playerInfo',
            'isMobile',
            'currentLocale',
            'currentSportType'
        ]),
    },
    methods: {
        
        formatDateTransfer(dateString) {
            // 拆分输入的日期字符串
            const [day,month,year] = dateString.split("/");
            const dateObj = new Date(`${year}-${month}-${day}`);
            let result = this.formatDateEndContract(dateObj)

            // 拼接结果
            return result;
        },
        formatDateEndContract(dateString) {
            // 拆分输入的日期字符串
            // const [year, month, day] = dateString.split("/");
            let date = new Date(dateString)
            // 使用项目提供的 this.$tools.getMonth() 获取月份缩写
            // const monthAbbreviation = this.$tools.getMonth(parseInt(month, 10) - 1); // 转换为 0 索引

            let result

            // 拼接结果
            // return `${day} ${this.$i18n.t(monthAbbreviation)} ${year}`;
            if (this.currentLocale === "vn") {
                result = `
              ${date.getDate()} tháng ${date.getMonth() + 1} năm
              ${date.getFullYear()} 
              
              `
          } else if (this.cnLocaleList.includes(this.currentLocale)) {
            result = `
                ${date.getDate()}日  
                ${date.getMonth() + 1}月
                ${date.getFullYear()}年
                `;
          } else {
            result = `
                ${date.getDate()} 
                ${this.$i18n.t(this.$tools.getMonth(date.getMonth()))}
                ${date.getFullYear()} 
                `;
          }
          return result
        }
    }
}
// $('[data-toggle="datepicker"]').datepicker();

</script>


<style>
.team-info__overview-header{
    margin: 0 1rem;
    margin-bottom: 1.45rem;
    font-size: .87rem;
    font-family: var(--weight-400);
}
.team-info__overview-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: .7rem;
    padding: .8rem 0.5rem;
    border-bottom: .1rem solid #212B30;
    color: var(--color-text-default-default);
    margin: 0 .5rem;
}
.team-info__overview-body:last-child{
    border-bottom:none
}
</style>

<style scoped>

.player-overview-container {
    display: flex;
    width: 1200px;
    margin: 32px auto;
    gap: 24px;
}
.player-overview-left {
    width: 396.5px;
}
.player-team {
    padding: 16px;
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    font-size: 14px;
	letter-spacing: 0.64px;
}
.player-team img {
    width: 44px;
}
.player-team-name {
    color: var(--color-text-default-default);
    font-family: var(--weight-600);
    font-size: 16px;
}
.player-team-date {
    color: var(--color-text-default-secondary);
}
.player-league {
    padding: 16px;
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
    letter-spacing: 0.56px;
    margin-bottom: 16px;
}
.player-league-box {
    display: flex;
    align-items: center;
    gap: 8px;
}
.player-league-country {
    color: var(--color-text-default-secondary);
    font-size: 14px;
	letter-spacing: 0.64px;
}
.player-league-name {
    font-family: var(--weight-600);
    font-size: 14px;
    color: var(--color-text-default-default);
    letter-spacing: .64px;
}
.player-league-box img {
    width: 40px;
}
.player-league-data {
    margin-top: 18px;
    margin-bottom: 6px;
    display: flex;
}
.player-league-data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 33.33%;
}
.player-league-data-item-title {
    color: var(--color-text-default-secondary);
    margin-bottom: 4px;
    text-align: center;
}
.player-league-data-item-value {
    font-family: var(--weight-600);
    color: var(--color-text-default-default);
}

.honours-awards-container {
    padding: 16px;
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
    letter-spacing: 0.56px;
    margin-bottom: 16px;
}
.honours-awards-title {
    font-size: 20px;
    font-family: var(--weight-600);
    margin-bottom: 30px;
    color: var(--color-text-default-default);
    letter-spacing: -0.6px;
}
.carrer-awards-title {
    font-size: 20px;
    font-family: var(--weight-600);
    margin-bottom: 20px;
    color: var(--color-text-default-default);
    letter-spacing: -0.6px;
}
.honours-awards-list {
}
.honours-awards-item:first-child {
    margin-top: 0;
}
.honours-awards-item {
    margin-top: 34px;
    
}
.honours-awards-child-list {
    margin-top: 26px;
    border: 1px solid #CED4DA;
    border-radius: 16px;
    font-size: 14px;
	letter-spacing: 0.64px;

}
.honours-awards-child-item {
    padding: 11px 16px;
    display: flex;
    align-items: center;
    gap: 9px;
}
.honours-awards-child-item img {
    width: 22px;
    border: 2px solid #CED4DA;
    border-radius: 50%;
}
.honours-awards-child-name {
    width: 100%;
}
.honours-awards-child-date {
    color: #6C757D;
}
.honours-awards-child-value {
    font-family: var(--weight-600);
}
.player-overview-center {
    width: 359px;
}
.career-history-table {
    font-size: 14px;
	letter-spacing: 0.64px;
}
.th-icon {
    width: 24px;
}
.career-history-table .player-team {
    padding: 0;
    text-align: left;
    margin-bottom: 0;
}
.career-history-table .player-team img {
    width: 35px;
}
.career-history-table td {
    padding: 8px 16px 8px 0;
}
.career-history-table td:nth-child(1) {
    padding-left: 0;
    width: 100%;
}
.career-history-table td:last-child {
    padding-right: 0;
}
.text-center {
    text-align: center;
}
.career-history-table-title {
    color: #6C757D;
    font-weight: bold
}
.national-team {
    border-top: 2px solid #CED4DA;
}
.national-team .career-history-table-title td {
    padding-top: 12px;
}
.career-history-table-title img {
    width: 24px;
}
.player-overview-right {
    width: 396.5px;
}
.transfer-history-list {

}
.transfer-history-item {
    border-bottom: 1px dashed var(--color-border-default-default);
    margin-bottom: 12px;
    padding-bottom: 12px;
    font-size: 14px;
	letter-spacing: 0.64px;
}
.transfer-history-item:last-child {
    border-bottom: 0;
    margin-bottom: 0;
}
.transfer-history-title {
    display: flex;
    align-items: center;
    color: #6C757D;
    justify-content: space-between;
    margin-bottom: 12px;
}
.transfer-history-amount {
    width: 114px;
    font-size: 14px;
    text-align: center;
    color: var(--color-text-default-netural);
    font-family: var(--weight-600);
    height: 20px;
    border-radius: 12px;
    background: var(--color-background-invite-card);
    display: flex;
    align-items: center;
    justify-content: center;
}
.player-info-mobile {
    display: none;
}

@media(max-width: 768px) {  /* for test */
.player-overview-container {
    display: block;
    width: 100%;
    margin: 22px auto 0;
}
.player-overview-left,
.player-overview-center,
.player-overview-right {
    width: 100%;    
}
.player-info-mobile {
    display: block;
}
.honours-awards-title {

}
.player-info-list {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    gap: 8px;
    row-gap: 24px;
}
.player-info-item {

}
.player-info-title {
    font-size: 13px;
    color: var(--gray-500);
}
.player-info-value {
    font-size: 14px;
    font-family: var(--weight-600);
    margin-top: 4px;
	letter-spacing: 0.64px;
    color: var(--color-text-default-default);
    font-size: 13px;
}
.honours-awards-title {
    margin-top: 12px;
}
.player-overview-left,
.player-overview-center,
.player-overview-right {
    padding: 0 8px;
    box-sizing: border-box;
}
.player-league-country {
    letter-spacing: .52px;
    font-size: 13px;
}
.carrer-container .honours-awards-title {
    margin-bottom: 8px;
}
.player-team,
.player-info-mobile,
.player-league,
.honours-awards-container {
    margin-bottom: 8px;
}
}
</style>

<style>
.transfer-history-list .player-league-box .icon-league {
    width: 40px;
    height: 40px;
}
.transfer-history-list .player-league-box .icon-league img {
    width: 35.94px;
    height: 35.94px;
    padding: 2.03px;
}
</style>

<style>
.logo-size {
    width: 40px;
    height: 40px;
}
</style>